import { Injectable } from '@angular/core';

@Injectable()
export class TimeFormatService {
    // Convert time to 12-hour format
    to12HourFormat(time: string): string {
        const [hours, minutes] = time.split(':').map(Number);
        const period = hours >= 12 ? 'PM' : 'AM';
        const adjustedHours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format
        return `${this.padZero(adjustedHours)}:${this.padZero(minutes)} ${period}`;
    }

    // Convert time to 24-hour format
    to24HourFormat(time12:string):string {
        const [time, modifier] = time12.trim().toUpperCase().split(' ');
        let [hour, minute] = time.split(':').map(str => parseInt(str, 10));
      
        if (modifier === 'PM' && hour < 12) hour += 12;
        if (modifier === 'AM' && hour === 12) hour = 0;
      
        return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
      }

    // Helper method to pad single-digit numbers with a leading zero
    private padZero(num: number): string {
        return num < 10 ? `0${num}` : `${num}`;
    }
}